import BossModel from "@/models/BossModel";
import CustomerTraveller from "@/models/Customer/Traveller/Traveller";
import constants from "@/constants";
import moment from "moment/moment";

export default class Version extends BossModel {

    static apiUrl = 'customer/traveller/version';
    static entity = 'customerTravellerVersions';

    static fields() {
        return {
            id: this.number(null).nullable(),
            customer_id: this.number(null),
            customer_traveller_id: this.number(null),
            relationship_cid: this.number(null).nullable(),
            firstname: this.attr(null),
            lastname: this.attr(null),
            date_of_birth: this.attr(null),
            age_group_cid: this.number(null),
            gender_cid: this.number(null),
            email: this.attr(null),
            amadeus_name: this.attr(null),
            frequent_flyer: this.attr(null),
            notes: this.attr(null),
            created_at: this.attr(null),
            traveller: this.belongsTo(CustomerTraveller, 'customer_traveller_id'),
        }
    }

    gender() {
        switch (this.gender_cid) {
            case 1:
                return 'Man';
            case 2:
                return 'Vrouw';
            case 0:
                return 'Anders';
            default:
                return 'Onbekend';
        }
    }

    AgeGroupCidOnDate(date, isTravalco = false) {
        let age = this.AgeOnDate(date);

        if (age === null) {
            return this.age_group_cid;
        }

        if (isTravalco) {
            if (age >= 19) {
                return 3;
            }

            return 2;
        }

        if (age <= 1) {
            return 1;
        }
        if (age >= 12) {
            return 3;
        }

        return 2;
    }

    AgeOnDate(date) {
        if (this.date_of_birth) {
            return date.diff(moment(this.date_of_birth), 'years');
        }

        return null;
    }

    AgeGroup() {
        let ageGroup = constants.ageGroups.find(item => item.id === this.age_group_cid);
        if (ageGroup === undefined) {
            return 'Onbekend';
        }

        return ageGroup.label;
    }

    AgeGroupOnDate(date) {
        let ageGroup = constants.ageGroups.find(group => group.id === this.AgeGroupCidOnDate(date));
        if (ageGroup === undefined) {
            return 'Onbekend';
        }

        return ageGroup.label;
    }

    AgeGroupIcon(date, isTravalco = false) {
        if (!date) {
            date = moment();
        }
        if (this.IsBabyOnDate(date, isTravalco)) {
            return 'mdi-baby-carriage';
        }
        if (this.IsChildOnDate(date, isTravalco)) {
            return 'mdi-human-handsup';
        }

        return 'mdi-human-male-female';
    }

    IsBabyOnDate(date, isTravalco = false) {
        return this.AgeGroupCidOnDate(date, isTravalco) === 1;
    }

    IsChildOnDate(date, isTravalco = false) {
        return this.AgeGroupCidOnDate(date, isTravalco) === 2;
    }

    IsAdultOnDate(date, isTravalco = false) {
        return this.AgeGroupCidOnDate(date, isTravalco) === 3;
    }
}
